var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-game-tile",class:{ 'home-game-tile--full': _vm.full }},[_c('div',{staticClass:"home-game-cover",on:{"click":function($event){return _vm.$emit('click')}}},[_c('img',{attrs:{"src":_vm.src,"alt":""}}),_vm._v(" "),(_vm.showBalance)?_c('span',{staticClass:"home-game-balance"},[_vm._v("¥"+_vm._s(_vm.balance))]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c1ccf2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomeGameTile.vue
// module id = null
// module chunks = 